var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMonthlyPayCertServiceMainMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 93,
    viewBox: "0 0 89 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2177_1339)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5191,
    y: 1.55723,
    width: 67.9613,
    height: 87.1976,
    rx: 2.80001,
    fill: "#F3F3F3",
    stroke: "#EDEDED",
    strokeWidth: 0.800002
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.1621,
    y: 53.9521,
    width: 52.7976,
    height: 3.51982,
    rx: 1.75991,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.1621,
    y: 44.5684,
    width: 52.7976,
    height: 3.51982,
    rx: 1.75991,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.1621,
    y: 63.3398,
    width: 52.7976,
    height: 3.51982,
    rx: 1.75991,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.1621,
    y: 72.7305,
    width: 37.5449,
    height: 3.51982,
    rx: 1.75991,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6625 18.6913L44.5118 14.3027L34.2032 18.6913V23.7802C34.2032 26.7215 33.9501 29.8029 37.4814 34.4716C39.3458 36.9365 42.9451 38.4245 44.5118 38.8602C45.6967 38.7046 48.7301 37.609 51.3843 34.4716C54.6625 30.5966 54.6757 26.0368 54.6625 23.7802V18.6913Z",
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3379 27.2706L43.0665 30.454L48.9785 23.1777",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2177_1339",
    x: -1.6141,
    y: 0.661133,
    width: 92.2262,
    height: 92.2262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.618
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.809002
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2177_1339"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2177_1339",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMonthlyPayCertServiceMainMobile);
export default __webpack_public_path__ + "static/media/IcMonthlyPayCertServiceMainMobile.a201f7666cf865dc435449e11071c1b6.svg";
export { ForwardRef as ReactComponent };